module.exports = __webpack_public_path__ + "img/rocket_text.8fec8003.png";